import { urlConfig } from "../../config/urlConfig";
import { AddTemplateReq, EmailTemplateDownloadReq, EmailTemplateReq, ReqTemplateType } from "../../types/EmailTemplateModel";
import { postCall, postCallSaveUpdateDeleteExcelData, postFileDownloadCall } from "../httpService";

const templateTypeUrl = urlConfig.TemplateType;
const addTemplateUrl = urlConfig.AddTemplate;
const emailTemplatebyIDUrl = urlConfig.GetEmailTemplatebyID;
const templateGroupUrl = urlConfig.GetTemplateGroup;
const emailtemplatestatusUpdateUrl = urlConfig.EmailtemplatestatusUpdate;
const emailTemplateUpdateUrl = urlConfig.EmailTemplateUpdate;
const emailTemplateDownload =urlConfig.EmailTemplateDownload;

export const getTemplateTypeData = async (advanceSearchModel: ReqTemplateType) => {
    try {
        const response = await postCall(templateTypeUrl, advanceSearchModel);
        return response.data;
    } catch (error) {
        console.log("Error in getTemplateTypeData ", error);
        throw error;
    }
};

export const AddTemplate = async (addTemplateReqModel: AddTemplateReq) => {
    try {
        const response = await postCall(addTemplateUrl, addTemplateReqModel);
        return response.data;
    } catch (error) {
        console.log("Error in AddTemplate ", error);
        throw error;
    }
};

export const GetEmailTemplateById = async (emailTemplateReqModel: EmailTemplateReq) => {
    try {
        const response = await postCall(emailTemplatebyIDUrl, emailTemplateReqModel);
        return response.data;
    } catch (error) {
        console.log("Error in GetEmailTemplateById ", error);
        throw error;
    }
};

export const GetTemplateGroup = async (templateGroupModel: EmailTemplateReq) => {
    try {
        const response = await postCall(templateGroupUrl, templateGroupModel);
        return response.data;
    } catch (error) {
        console.log("Error in GetTemplateGroup ", error);
        throw error;
    }
};

export const EmailtemplatestatusUpdate = async (templateGroupModel: EmailTemplateReq) => {
    try {
        const response = await postCall(emailtemplatestatusUpdateUrl, templateGroupModel);
        return response.data;
    } catch (error) {
        console.log("Error in EmailtemplatestatusUpdate ", error);
        throw error;
    }
};

export const EmailTemplateUpdate = async (addTemplateReqModel: AddTemplateReq) => {
    try {
        const response = await postCall(emailTemplateUpdateUrl, addTemplateReqModel);
        return response.data;
    } catch (error) {
        console.log("Error in EmailTemplateUpdate ", error);
        throw error;
    }
};

export const DownloadEmailTemplate = async (emailTemplateDownloadReq: EmailTemplateDownloadReq) => {
    try {
        const response = await postFileDownloadCall(emailTemplateDownload, emailTemplateDownloadReq);
        return response.data;
    } catch (error) {
        console.log("Error in DownloadEmailTemplate ", error);
        throw error;
    }
};

export const SaveUpdateDeleteExcelData = async (params: any) => {
  try {
    const response = await postCallSaveUpdateDeleteExcelData(params);
    return response.data;
  } catch (error) {
    console.log("Error in SaveUpdateDeleteExcelData ", error);
    throw error;
  }
};